// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { observer } from "mobx-react-lite";

import { Redirect } from "~@jii/common-ui";
import { StateCode } from "~@jii/configs";
import { stateConfigsByStateCode, useRootStore } from "~@jii/data";
import { EmailVerification, State, StateSelect } from "~@jii/paths";

import { PageLanding } from "./PageLanding";

export const PageHome = observer(function PageHome() {
  const {
    userStore: { authManager, allowedStates },
  } = useRootStore();

  let stateCode: StateCode | undefined;

  if (allowedStates.length === 1) {
    stateCode = allowedStates[0];
  } else if (allowedStates.length > 1) {
    return <Redirect to={StateSelect.buildPath({})} />;
  }

  if (stateCode)
    return (
      <Redirect
        to={State.buildPath({
          stateSlug: stateConfigsByStateCode[stateCode].urlSlug,
        })}
      />
    );

  if (authManager.isEmailVerificationRequired)
    return <Redirect to={EmailVerification.buildPath({})} />;

  return <PageLanding />;
});
